////////////////////////////////////////
// IMPORTING MODULES
////////////////////////////////////////

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

////////////////////////////////////////
// FUNCTION: CN
////////////////////////////////////////

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};
